import { render, staticRenderFns } from "./sidebarOne.vue?vue&type=template&id=4452b67c&"
import script from "./sidebarOne.vue?vue&type=script&lang=js&"
export * from "./sidebarOne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports